import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export type Announcement = {
  id: string;
  title: string;
  body_html: string | null;
  severity: 'info' | 'success' | 'warning' | 'announcement';
  link_url: string | null;
  link_label: string | null;
  published_at: number;
  dismissible: boolean;
  pinned: boolean;
};

export function useAnnouncements() {
  return useQuery({
    queryKey: ['announcements'],
    queryFn: () => api.get<{ announcements: Announcement[] }>('/api/app/announcements'),
    staleTime: 60_000,
  });
}

export function useDismissAnnouncement() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post<{ dismissed: boolean }>(`/api/app/announcements/${id}/dismiss`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['announcements'] }),
  });
}
